import React from 'react'

export function Backdrop({
  children,
  onClose,
}: {
  children: React.ReactChild
  onClose: (e: any) => void
}) {
  const handleOnClose = (e: any) => {
    if (e.target === e.currentTarget) {
      onClose(e)
    }
  }

  return (
    <div onClick={handleOnClose} className="rws-backdrop web-share-fade">
      {children}
    </div>
  )
}
